import type { ReactNode } from 'react';

type PopoverProps = {
  children: ReactNode;
};

export function Sidebar({ children }: PopoverProps) {
  return (
    <div
      className="group sticky top-0 flex h-screen w-auto flex-col gap-sm bg-default text-default"
      data-testid="main-nav-sidebar"
    >
      {children}
    </div>
  );
}

Sidebar.displayName = 'Sidebar';
